import { createBaseApi } from '../baseApi';

// Create base top picks API
const topPicksApi = createBaseApi('topPicksApi');

// Enhanced API with top picks endpoints
export const enhancedTopPicksApi = topPicksApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get active top picks for Explore section
    getTopPicks: builder.query({
      query: () => '/top-picks',
      providesTags: ['TopPicks'],
      transformResponse: (response) => {
        if (response?.success && response?.data) {
          return response.data.map(item => ({
            id: item.id,
            type: item.type,
            imageUrl: item.imageUrl,
            name: item.name,
            priority: item.priority,
            itemId: item.itemId
          }));
        }
        return [];
      }
    }),

    // Add item to top picks (admin only)
    addTopPick: builder.mutation({
      query: ({ closetClothesId, virtualTryOnResultId, priority }) => ({
        url: '/top-picks',
        method: 'POST',
        body: { closetClothesId, virtualTryOnResultId, priority }
      }),
      invalidatesTags: ['TopPicks']
    }),

    // Update top pick priority (admin only)
    updateTopPick: builder.mutation({
      query: ({ id, priority, isActive }) => ({
        url: `/top-picks/${id}`,
        method: 'PUT',
        body: { priority, isActive }
      }),
      invalidatesTags: ['TopPicks']
    }),

    // Remove item from top picks (admin only)
    removeTopPick: builder.mutation({
      query: (id) => ({
        url: `/top-picks/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['TopPicks']
    })
  })
});

export const {
  useGetTopPicksQuery,
  useAddTopPickMutation,
  useUpdateTopPickMutation,
  useRemoveTopPickMutation
} = enhancedTopPicksApi;

export default enhancedTopPicksApi;
